/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { FormElementProps } from '@/auth/types';
import { TextArea } from '@adobe-commerce/elsie/components';
import { memo } from 'preact/compat';
import { FieldElement } from './FieldElement';

export const TextAreaElement = memo(
  ({
    item,
    valueMessage,
    errorConfig,
    onBlur,
    onChange,
    className,
    itemClassName,
    loading,
  }: FormElementProps) => {
    return (
      <FieldElement
        item={item}
        errorConfig={errorConfig}
        className={className}
        itemClassName={itemClassName}
        loading={loading}
      >
        <TextArea
          name={item.customUpperCode}
          value={valueMessage ?? item.defaultValue}
          label={`${item.label} ${item.required ? '*' : ''}`}
          onBlur={onBlur}
          onChange={onChange}
        />
      </FieldElement>
    );
  }
);
